<div class="loading-screen">
  <div class="loading-screen-bg"></div>
  <div class="loading-screen-card">
    <div class="loading-spinner-wrap">
      <div class="loading-spinner-rings">
        <span class="ring ring-1"></span>
        <span class="ring ring-2"></span>
        <span class="ring ring-3"></span>
      </div>
      <div class="loading-spinner-logo">
        <i class="pi pi-chart-bar"></i>
      </div>
    </div>
    <div class="loading-brand">
      <span class="loading-brand-name">APEX</span>
      <span class="loading-brand-sub">BISTEC Global</span>
    </div>
    <p class="loading-message">{{ currentMessage }}</p>
    <div class="loading-dots">
      <span class="dot" [class.active]="currentMessageIndex === 0"></span>
      <span class="dot" [class.active]="currentMessageIndex === 1"></span>
      <span class="dot" [class.active]="currentMessageIndex === 2"></span>
      <span class="dot" [class.active]="currentMessageIndex === 3"></span>
    </div>
    <div class="loading-progress">
      <div class="loading-progress-fill"></div>
    </div>
  </div>
</div>
